var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mediumTags",attrs:{"id":"MediumTagShortInfo-container"}},_vm._l((_vm.mediumTags),function(mediumTag){return _c('div',{key:mediumTag.id,staticClass:"tag",attrs:{"id":'MediumTagShortInfo-tag' + mediumTag.id}},[_vm._v(_vm._s(mediumTag))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d1a9ef2a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Medium/MediumTagsShortInfo.vue
// module id = null
// module chunks = 